import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import tokenService from '../../../Common/tokenDecoder';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import tokenDecoder from '../../../Common/tokenDecoder';
import { use } from 'react';

const screenCode = 'SESSIONTIMECONFIGURATION';

export function SessionTimeConfigListing(props) {
    const [groups, setGroups] = useState([]);
    const [filteredEstates, setFilteredEstates] = useState({});
    const [multipleEstates, setMultipleEstates] = useState({});
    const [divisions, setDivisions] = useState({});
    const [errors, setErrors] = useState({});
    const [configDetails, setConfigDetails] = useState([]);
    const [isTableVisible, setIsTableVisible] = useState(false);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
        isAddEditEnabled: false,
    });
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteRecord, setDeleteRecord] = useState(null);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editRecord, setEditRecord] = useState(null);
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: 'Success',
        disciption: '',
    });
    const [searchValue, setSearchValue] = useState({
        groupID: '0',
        estateID: '0',
        divisionID: '0',
    });

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        if (props.location && props.location.state && props.location.state.savedStatus) {
            setMessageModel({
                hidden: false,
                type: props.location.state.savedStatus,
                disciption: props.location.state.savedMessage || 'Saved successfully.',
            });
            setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 2500);
            props.history.replace({ pathname: props.location.pathname, state: undefined });
        }
    }, []);

    useEffect(() => {
        if (searchValue.groupID !== '0') {
            getEstatesForDropdown();
        } else {
            setFilteredEstates({});
            setDivisions({});
            setSearchValue(prev => ({ ...prev, estateID: '0', divisionID: '0' }));
        }
        setConfigDetails([]);
        setIsTableVisible(false);
    }, [searchValue.groupID]);

    useEffect(() => {
        if (searchValue.estateID !== '0') {
            getDivisionsForDropDown(searchValue.estateID);
            getMenuCodesForDropDown(searchValue.estateID);
        } else {
            setDivisions({});
            setSearchValue(prev => ({ ...prev, divisionID: '0' }));
        }
        setConfigDetails([]);
        setIsTableVisible(false);
    }, [searchValue.estateID]);

    useEffect(() => {
        setConfigDetails([]);
        setIsTableVisible(false);
    }, [searchValue.divisionID]);

    const handleChange = e => {
        const { name, value } = e.target;
        setErrors(prev => { const err = { ...prev }; delete err[name]; return err; });
        setSearchValue(prev => ({ ...prev, [name]: value }));
    };

    const handlePageChange = (event, newPage) => setPage(newPage);
    const handleLimitChange = event => { setLimit(event.target.value); setPage(0); };

    function normalizeTimeValue(timeValue) {
        if (!timeValue) return '';
        const match = String(timeValue).match(/^(\d{1,2}):(\d{1,2})/);
        if (!match) return '';
        const hour = String(parseInt(match[1], 10)).padStart(2, '0');
        const minute = String(parseInt(match[2], 10)).padStart(2, '0');
        return `${hour}:${minute}`;
    }

    function getTimeParts(timeValue) {
        const normalized = normalizeTimeValue(timeValue);
        if (!normalized) return { hour: '00', minute: '00' };
        const [hour, minute] = normalized.split(':');
        return { hour: hour || '00', minute: minute || '00' };
    }

    function getMinutesFromTime(timeValue) {
        const { hour, minute } = getTimeParts(timeValue);
        return parseInt(hour, 10) * 60 + parseInt(minute, 10);
    }

    function handleTimeChange(fieldName, part, value) {
        setEditRecord(prev => {
            if (!prev) return prev;
            const current = getTimeParts(prev[fieldName]);
            const nextTime = part === 'hour'
                ? `${value}:${current.minute}`
                : `${current.hour}:${value}`;
            return { ...prev, [fieldName]: nextTime };
        });
    }

    async function handleSearch(e) {
        e.preventDefault();

        let newErrors = {};
        if (!searchValue.groupID || searchValue.groupID === '0') {
            newErrors.groupID = 'Group is required';
        }
        if (!searchValue.estateID || searchValue.estateID === '0') {
            newErrors.estateID = 'Operation Entity is required';
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});

        const payload = {
            groupID: parseInt(searchValue.groupID),
            factoryID: parseInt(searchValue.estateID),
            divisionID: searchValue.divisionID !== '0' ? parseInt(searchValue.divisionID) : 0,
        };

        try {
            const response = await services.getSectionTimeConfigurations(payload);
            if (!response || response.length === 0) {
                setIsTableVisible(false);
                setConfigDetails([]);
                setMessageModel({ hidden: false, type: 'Warning', disciption: 'No records found.' });
                setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
                return;
            }
            setConfigDetails(response);
            setIsTableVisible(true);
            setPage(0);
        } catch (err) {
            setMessageModel({ hidden: false, type: 'Error', disciption: 'Failed to load records.' });
            setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
        }
    }

    function handleDeleteClick(record) {
        setDeleteRecord(record);
        setDeleteDialogOpen(true);
    }

    function handleDeleteDialogClose() {
        setDeleteDialogOpen(false);
        setDeleteRecord(null);
    }

    function handleEditClick(record) {
        setEditRecord({
            ...record,
            startTime: normalizeTimeValue(record.startTime),
            endTime: normalizeTimeValue(record.endTime),
        });
        setEditDialogOpen(true);
    }

    function handleEditDialogClose() {
        setEditDialogOpen(false);
        setEditRecord(null);
    }

    function handleEditChange(e) {
        const { name, value } = e.target;
        setEditRecord(prev => ({ ...prev, [name]: value }));
    }

    async function handleEditConfirm() {
        if (!editRecord) return;

        if (!editRecord.startTime || !editRecord.endTime) {
            setMessageModel({ hidden: false, type: 'Error', disciption: 'Both Start Time and End Time are required.' });
            setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
            return;
        }

        // if (getMinutesFromTime(editRecord.endTime) <= getMinutesFromTime(editRecord.startTime)) {
        //     setMessageModel({ hidden: false, type: 'Error', disciption: 'End Time must be after Start Time.' });
        //     setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
        //     return;
        // }

        setEditDialogOpen(false);
        try {
            const startTimeFormatted = editRecord.startTime.length === 5 ? editRecord.startTime + ':00' : editRecord.startTime;
            const endTimeFormatted = editRecord.endTime.length === 5 ? editRecord.endTime + ':00' : editRecord.endTime;
            const userId = parseInt(tokenService.getUserIDFromToken());

            const response = await services.updateSectionTimeConfiguration(
                editRecord.sessionTimeConfigurationID,
                userId,
                startTimeFormatted,
                endTimeFormatted
            );

            if (response.statusCode === 'Success') {
                const updatedId = editRecord.sessionTimeConfigurationID || editRecord.sectionTimeConfigurationID;
                setConfigDetails(prev => prev.map(item => {
                    const itemId = item.sessionTimeConfigurationID || item.sectionTimeConfigurationID;
                    if (itemId === updatedId) {
                        return {
                            ...item,
                            startTime: startTimeFormatted,
                            endTime: endTimeFormatted,
                        };
                    }
                    return item;
                }));
                setIsTableVisible(true);
                setPage(0);
                setMessageModel({ hidden: false, type: 'Success', disciption: response.message || 'Record updated successfully.' });
                setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 2500);
            } else {
                setMessageModel({ hidden: false, type: 'Error', disciption: response.message || 'Update failed.' });
                setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
            }
        } catch (err) {
            setMessageModel({ hidden: false, type: 'Error', disciption: 'Update failed. Please try again.' });
            setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
        } finally {
            setEditRecord(null);
        }
    }

    async function handleDeleteConfirm() {
        if (!deleteRecord) return;
        setDeleteDialogOpen(false);
        try {
            const response = await services.deleteSectionTimeConfiguration(
                deleteRecord.sessionTimeConfigurationID,
                parseInt(tokenService.getUserIDFromToken())
            );
            if (response.statusCode === 'Success') {
                const deletedId = deleteRecord.sessionTimeConfigurationID || deleteRecord.sectionTimeConfigurationID;
                setConfigDetails(prev => prev.filter(item => (item.sessionTimeConfigurationID || item.sectionTimeConfigurationID) !== deletedId));
                setIsTableVisible(true);
                setMessageModel({ hidden: false, type: 'Success', disciption: response.message || 'Record deleted successfully.' });
                setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 2500);
            } else {
                setMessageModel({ hidden: false, type: 'Error', disciption: response.message || 'Delete failed.' });
                setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
            }
        } catch (err) {
            setMessageModel({ hidden: false, type: 'Error', disciption: 'Delete failed. Please try again.' });
            setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
        } finally {
            setDeleteRecord(null);
        }
    }

    function clearSearch() {
        const token = tokenDecoder.getUserDetailsFromTokenV2();
        setSearchValue({
            groupID: token.groupID || '0',
            estateID: token.operationEntityID || '0',
            divisionID: '0'
        });
        setConfigDetails([]);
        setIsTableVisible(false);
        setErrors({});
        setPage(0);
    }

    function modalDismissHandler() {
        setMessageModel(prev => ({ ...prev, hidden: true }));
    }

    async function getPermissions() {
        try {
            const permissions = await authService.getPermissionsByScreen(screenCode);
            const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWSESSIONTIMECONFIGURATION');
            if (!isAuthorized) {
                props.history.push('/unauthorized');
                return;
            }
            const isAddEditEnabled = permissions.find(p => p.permissionCode === 'ADDEDITSESSIONTIMECONFIGURATION');
            const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
            const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

            setPermissions({
                isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
                isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
                isAddEditEnabled: isAddEditEnabled !== undefined,
            });

            const token = tokenService.getUserDetailsFromTokenV2();
            let estateArray = {};
            if (token.operationEntities && token.operationEntities.length > 0) {
                token.operationEntities.forEach(item => {
                    estateArray[item.OperationEntityID] = item.OperationEntityName;
                });
            }
            setMultipleEstates(estateArray);
            setSearchValue(prev => ({
                ...prev,
                groupID: token.groupID || '0',
                estateID: token.operationEntityID || '0'
            }));

            await getAllGroups();
        } catch (error) {
            setMessageModel({ hidden: false, type: 'Error', disciption: 'Failed to load permissions.' });
        }
    }

    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function getEstatesForDropdown() {
        try {
            const apiEstates = await services.getEstatesByGroupID(searchValue.groupID);
            const apiEstatesObject = {};
            apiEstates.forEach((name, index) => {
                if (name !== null && name !== undefined) {
                    apiEstatesObject[String(index)] = name;
                }
            });
            let estatesToShow = {};
            if (Object.keys(multipleEstates).length === 0) {
                estatesToShow = apiEstatesObject;
            } else {
                estatesToShow = Object.keys(apiEstatesObject).reduce((acc, key) => {
                    if (multipleEstates[key]) acc[key] = multipleEstates[key];
                    return acc;
                }, {});
            }
            setFilteredEstates(estatesToShow);
            setSearchValue(prev => {
                if (prev.estateID !== '0' && estatesToShow[prev.estateID]) {
                    return prev;
                }
                return { ...prev, estateID: '0', divisionID: '0' };
            });
        } catch (error) {
            setErrors(prev => ({ ...prev, estateID: 'Failed to load factories.' }));
        }
    }

    async function getDivisionsForDropDown(estateID) {
        try {
            const data = await services.getDivisionByEstateID(estateID);
            setDivisions(data);
            setSearchValue(prev => {
                if (prev.divisionID !== '0' && data[prev.divisionID]) {
                    return prev;
                }
                return { ...prev, divisionID: '0' };
            });
        } catch (error) {
            setErrors(prev => ({ ...prev, divisionID: 'Failed to load divisions.' }));
        }
    }

    async function getMenuCodesForDropDown(estateID) {
        try {
            const data = await services.getMenuCode(estateID);
            return data;
        } catch (error) {
            setErrors(prev => ({ ...prev, menuCode: 'Failed to load menu codes.' }));
            return [];
        }
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>{value}</MenuItem>
        ));
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Session Time Configuration"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Session Time Configuration"
                            path="/SessionTimeConfiguration/addEdit"
                        />

                        <div className="card-body">
                            <form onSubmit={e => trackPromise(handleSearch(e))}>
                                <div className="form-group row">

                                    {/* Group */}
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={searchValue.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors['groupID'] && (
                                            <FormHelperText error>{errors['groupID']}</FormHelperText>
                                        )}
                                    </div>

                                    {/* Factory */}
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={searchValue.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(filteredEstates)}
                                        </Select>
                                        {errors['estateID'] && (
                                            <FormHelperText error>{errors['estateID']}</FormHelperText>
                                        )}
                                    </div>

                                    {/* Division */}
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="divisionID">Collection Point</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={searchValue.divisionID}
                                            disabled={searchValue.estateID === '0' || Object.keys(divisions).length === 0}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="0">--All Collection Points--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors['divisionID'] && (
                                            <FormHelperText error>{errors['divisionID']}</FormHelperText>
                                        )}
                                    </div>

                                </div>
                            </form>

                            {/* Search & Clear — bottom-right footer */}
                            <div className="card-footer">
                                <div className="d-flex justify-content-end">
                                    <input
                                        type="button"
                                        className="btn btn-warning mr-2"
                                        value="Clear"
                                        onClick={clearSearch}
                                    />
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>

                            {/* Results Table */}
                            {isTableVisible && configDetails.length > 0 && (
                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        <Box display="flex" justifyContent="flex-end" p={2}>
                                            <TableContainer component={Paper} style={{ width: '100%' }}>
                                                <Table aria-label="session time configuration list">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                                Operation Entity
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                                Collection Point
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                                Menu Name
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                                Session
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                                Start Time
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                                End Time
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                                Action
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {configDetails
                                                            .slice(page * limit, page * limit + limit)
                                                            .map((row, index) => (
                                                                <TableRow key={row.sectionTimeConfigurationID || index}>
                                                                    <TableCell align="center">
                                                                        {filteredEstates[row.factoryID] || row.operationEntityName || '-'}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {divisions[row.divisionID] || row.divisionName || '-'}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {row.menuName || '-'}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {row.sessionName
                                                                            ? 'Session ' + row.sessionName.replace(/^Session\s*/i, '').trim()
                                                                            : '-'}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {row.startTime || '-'}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {row.endTime || '-'}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleEditClick(row)}
                                                                            title="Edit"
                                                                            aria-label="Edit"
                                                                            disabled={!permissionList.isAddEditEnabled}
                                                                        >
                                                                            <EditIcon color="primary" fontSize="small" />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleDeleteClick(row)}
                                                                            title="Delete"
                                                                            aria-label="Delete"
                                                                            disabled={!permissionList.isAddEditEnabled}
                                                                        >
                                                                            <DeleteIcon color="error" fontSize="small" />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                    </TableBody>
                                                </Table>
                                                <TablePagination
                                                    component="div"
                                                    count={configDetails.length}
                                                    onChangePage={handlePageChange}
                                                    onChangeRowsPerPage={handleLimitChange}
                                                    page={page}
                                                    rowsPerPage={limit}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                />
                                            </TableContainer>
                                        </Box>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />

            <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteDialogClose}
                aria-labelledby="delete-dialog-title"
                aria-describedby="delete-dialog-description"
            >
                <DialogTitle id="delete-dialog-title">Delete Session Time Configuration</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-dialog-description">
                        Are you sure you want to delete this record?<br />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteDialogClose} color="primary">
                        No
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="secondary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={editDialogOpen}
                onClose={handleEditDialogClose}
                aria-labelledby="edit-dialog-title"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="edit-dialog-title">Edit Session Time Configuration</DialogTitle>
                <DialogContent>
                    {editRecord && (
                        <>
                            <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                                <strong>Factory:</strong> {filteredEstates[editRecord.factoryID] || editRecord.operationEntityName || '-'}
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <strong>Division:</strong> {divisions[editRecord.divisionID] || editRecord.divisionName || '-'}
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <strong>Session:</strong> {editRecord.sessionName
                                    ? 'Session ' + editRecord.sessionName.replace(/^Session\s*/i, '').trim()
                                    : editRecord.sessionID ? `Session ${editRecord.sessionID}` : '-'}
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <InputLabel shrink id="start-time-label">Start Time</InputLabel>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Select
                                        fullWidth
                                        labelId="start-time-label"
                                        value={getTimeParts(editRecord.startTime).hour}
                                        onChange={e => handleTimeChange('startTime', 'hour', e.target.value)}
                                    >
                                        {Array.from({ length: 24 }, (_, index) => String(index).padStart(2, '0')).map(hour => (
                                            <MenuItem key={hour} value={hour}>{hour}</MenuItem>
                                        ))}
                                    </Select>
                                    <Select
                                        fullWidth
                                        value={getTimeParts(editRecord.startTime).minute}
                                        onChange={e => handleTimeChange('startTime', 'minute', e.target.value)}
                                    >
                                        {Array.from({ length: 60 }, (_, index) => String(index).padStart(2, '0')).map(minute => (
                                            <MenuItem key={minute} value={minute}>{minute}</MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                            </div>
                            <div>
                                <InputLabel shrink id="end-time-label">End Time</InputLabel>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Select
                                        fullWidth
                                        labelId="end-time-label"
                                        value={getTimeParts(editRecord.endTime).hour}
                                        onChange={e => handleTimeChange('endTime', 'hour', e.target.value)}
                                    >
                                        {Array.from({ length: 24 }, (_, index) => String(index).padStart(2, '0')).map(hour => (
                                            <MenuItem key={hour} value={hour}>{hour}</MenuItem>
                                        ))}
                                    </Select>
                                    <Select
                                        fullWidth
                                        value={getTimeParts(editRecord.endTime).minute}
                                        onChange={e => handleTimeChange('endTime', 'minute', e.target.value)}
                                    >
                                        {Array.from({ length: 60 }, (_, index) => String(index).padStart(2, '0')).map(minute => (
                                            <MenuItem key={minute} value={minute}>{minute}</MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                            </div>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEditDialogClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleEditConfirm} color="secondary" autoFocus>
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}
